"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PROMISE_DOESNT_EXIST: "Provided promise doesn't exist"
};